import {useState, useRef} from "react";
import { FiMenu } from "react-icons/fi";
import Typed from 'react-typed';

import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import Darkmode from "./Darkmode";
import useStickyHeader from "./useStickyHeader";

const HeaderTwo = ({btnStyle, HeaderSTyle ,ofcanvasShow, setOffcanvasShow}) => {
    const onCanvasHandler = () => {
        setOffcanvasShow(prev => !prev);
    }


    const ref = useRef();
    let [check, setCheck] = useState(true);
    const sticky = useStickyHeader( 50 );
    const headerClasses = `header-default ${(sticky && check) ? 'sticky' : ''}`
    const { clientHeight } = ref;
    
    const checkChange = (value) => {
      setCheck(value);
    };

    return (
        <>
            <header ref={ref} className={`rn-header header-default header-left-align ${HeaderSTyle} ${headerClasses}`}>
                <div className=" position-relative">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-md-6 col-3 position-static">
                            <div className="header-left d-flex">
                                <Logo 
                                    image={`${process.env.PUBLIC_URL}./logo.svg`}
                                    image2={`${process.env.PUBLIC_URL}./logo.svg`}
                                />
                                <nav className="mainmenu-nav d-none d-lg-block">
                                    
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-9">
                            <div className="header-right">
                                <div className="header-btn">
                                    <a className={`btn-default ${btnStyle}`} target="_blank" href="/world/tienda/">iCotiza Ahora!</a>
                                </div>
                                <div className="mobile-menu-bar ml--5 d-block ">
                                    <div className="hamberger">
                                        <button className="hamberger-button" onClick={onCanvasHandler}>MENU</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu show={ofcanvasShow} onClose={onCanvasHandler}  />
        </>
    )
}
export default HeaderTwo;